import { render, staticRenderFns } from "./create-roles.component.html?vue&type=template&id=0f4ffe46&scoped=true&"
import script from "./create-roles.component.ts?vue&type=script&lang=ts&"
export * from "./create-roles.component.ts?vue&type=script&lang=ts&"
import style0 from "./create-roles.component.scss?vue&type=style&index=0&id=0f4ffe46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ffe46",
  null
  
)

export default component.exports